import { isDefinedArray, reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { observable, runInAction } from "mobx";

import { apiCallGetUserPromoCodeUsageData } from "../../../api/user-api/api-call-get-user-promo-code-usage-data";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { TEt3PickerSingleValue, TRewardBenefitType } from "../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";

class PromoCodeUsageStore {
  promoCodeUsageUserid = observable.box<number>(0);
  promoCodeUsageLimit = observable.box<TEt3PickerSingleValue>({
    label: "10",
    value: "10"
  });
  promoCodeDataUsage = observable.box<
    {
      promocode: string;
      isUserRewarded: string;
      rewardType: TRewardBenefitType;
      rewardAmountInHours: number;
      reason: string;
      source: string;
      createdOn: string;
    }[]
  >([]);
  setPromoCodeUsageLimit = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.promoCodeUsageLimit.set(limit);
    });
  };
  getUserPromoCodeUsage = async () => {
    try {
      getCoreUIStore().setIsLoading("USER_PROMO_CODE_USAGE", true);
      const result = await apiCallGetUserPromoCodeUsageData({
        userId: this.promoCodeUsageUserid.get(),
        limit: reducerToZeroIfUndefined(
          parseInt(this.promoCodeUsageLimit.get().value, 10)
        )
      });
      getCoreUIStore().setIsLoading("USER_PROMO_CODE_USAGE", false);
      const resultsArray = reduce(() => result.data, []);
      if (!isDefinedArray(resultsArray)) {
        getCorePopUpStore().showAlertMessage("NO_RESULT");
        return;
      }
      const newResultsArray = resultsArray.map((item) => {
        return {
          ...item,
          isUserRewarded: item.isUserRewarded ? "Yes" : "No"
        };
      });
      this.promoCodeDataUsage.set(newResultsArray);
    } catch (err) {}
  };
}

const getPromoCodeUsageStore = memoize(
  () => new PromoCodeUsageStore(),
  () => 1
);
export default getPromoCodeUsageStore;
